import {useDebugValue, useState} from 'react';

import {useInitialization} from '../../../hooks';
import {getCookieValues} from '../../../utils';

const initialValues = {
    destinationValues: {},
    datesValues: {},
    guestsValues: {}
};

function useCookies() {
    const [
        values,
        setValues
    ] = useState(initialValues);

    function updateValues(nextValues) {
        setValues(nextValues);
    }

    useInitialization(function initializeValues() {
        const cookieValues = getCookieValues();

        updateValues(cookieValues);
    });

    const result = values;

    useDebugValue(result);

    return result;
}

export {useCookies};
